function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.997 4.999v6c0 1.658-1.342 3-2.999 3h-5c-1.658 0-3-1.342-3-3v-6a1 1 0 110-2h2c0-1.658 1.342-3 3-3h.999a3 3 0 013 3h2a1.001 1.001 0 010 2zm-5-3h-.999a1 1 0 00-1.001 1h3a1 1 0 00-1-1zm3 3H2.998v6a1 1 0 001 1h5a1 1 0 00.999-1v-6zm-2 6a1 1 0 01-1-1v-3a1 1 0 012.001 0v3a1 1 0 01-1.001 1zm-3 0a1 1 0 01-.999-1v-3a1 1 0 112 0v3a1 1 0 01-1.001 1z"
});

var SvgTrash = function SvgTrash(props) {
  return React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDEzIDE0Ij4KICAgIDxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTEuOTk3IDQuOTk5djZjMCAxLjY1OC0xLjM0MiAzLTIuOTk5IDNoLTVjLTEuNjU4IDAtMy0xLjM0Mi0zLTN2LTZhMSAxIDAgMSAxIDAtMmgyYzAtMS42NTggMS4zNDItMyAzLTNoLjk5OWEzIDMgMCAwIDEgMyAzaDJhMS4wMDEgMS4wMDEgMCAwIDEgMCAyem0tNS0zaC0uOTk5YTEgMSAwIDAgMC0xLjAwMSAxaDNhMSAxIDAgMCAwLTEtMXptMyAzSDIuOTk4djZhMSAxIDAgMCAwIDEgMWg1YTEgMSAwIDAgMCAuOTk5LTF2LTZ6bS0yIDZhMSAxIDAgMCAxLTEtMXYtM2ExIDEgMCAwIDEgMi4wMDEgMHYzYTEgMSAwIDAgMS0xLjAwMSAxem0tMyAwYTEgMSAwIDAgMS0uOTk5LTF2LTNhMSAxIDAgMSAxIDIgMHYzYTEgMSAwIDAgMS0xLjAwMSAxeiIvPgo8L3N2Zz4K";
export { SvgTrash as ReactComponent };